// extracted by mini-css-extract-plugin
module.exports = {"pageName":"SalesForecast_pageName__1wuan"};